import { getSchoolUrl } from "../../utils/urls"

export const getRegistrationLink = (registration) => {
  return {
    pathname: `/library/${registration.resource.slug}/${registration.group.id}/path/`,
    state: { setResourceLaunchedFrom: true },
    query: { path_mode: 5 }
  }
}

// TODO: this logic should be GraphQL-side ideally
export const getCertificateDownloadUrl = (pwContext, registration) => {
  // ensure resource has certificate and path is complete
  if (
    registration.path.progress < 1 ||
    !registration.path.completion_date ||
    !pwContext.school.has_certificate ||
    !registration.resource.has_certificate
  )
    return null
  // other users shouldn't have access to certificate
  if (!pwContext.me || pwContext.me.id !== registration.user.id) return null

  return getSchoolUrl(
    `/certgen/certificate/${registration.resource.slug}/${
      registration.path.id
    }?sso=${localStorage.getItem("auth_token")}`
  )
}
